// extracted by mini-css-extract-plugin
module.exports = {"defaultButton":"style_defaultButton__ch0a5","button":"style_button__2NB1i","loading":"style_loading__2TbSY","spinning":"style_spinning__36PZH"};